import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { LandingPageService } from './../../../../../core/services/landing-page.service';
import { ConsumerAcceptTeamsComponent } from '../consumer-accept-teams/consumer-accept-teams.component';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from '../../../../../core/services/validation.service';
import { AppService } from '../../../../../core/services/app.service';
import { environment } from '../../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { API, AWS_RES_STATUS_CODE, CONST_AWS_API } from 'src/app/core/constants';
import * as moment from 'moment';
import { API as AWS_API, Auth } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConsumerVerificationCodeComponent } from '../consumer-verification-code/consumer-verification-code.component';
import { Subscription } from 'rxjs';
import { StorageService } from 'src/app/core/services/storage.service';
import { UserService } from 'src/app/core/services/user.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { getNetworkLogo } from 'src/app/core/utils/network-logo.util';
import { getGroupSegment } from 'src/app/core/utils/group-url.util';
const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
declare let $: any;
declare let ga: Function;

@Component({
  selector: 'app-consumer-signup',
  templateUrl: './consumer-signup.component.html',
  styleUrls: ['./consumer-signup.component.scss']
})
export class ConsumerSignupComponent implements OnInit {

  signUpForm: FormGroup;
  captcharesponse: any = "";
  captchaKey: any = environment.captchaKey;
  userInfo: any = {};
  passwordIsValid = false;
  isAgrees = false;
  userInfoSubscription: Subscription;
  featureInfoSubscription: Subscription;
  signUpInfoSubscription: Subscription;
  settingsDataSubscription: Subscription;
  performerInfoSubscription!: Subscription;
  signUpInfo: any;
  organizationId: number = 0;
  getEventData: any = {};
  returnUrl = '';
  liveEventInfo: any;
  settingsData: any = {}
  channelUrl: any;
  routerevents: any;
  referralCode: string;
  mobileCallback: string;
  channelName: any;
  /** New-design sign-up page (ENABLE_NEW_SIGNUP, ConsumerSignupV2Component); the classic page is kept for false. */
  newSignup = (environment as any).enableNewSignup === true;

  get networkLogo(): string {
    return getNetworkLogo(this.commanSubscribeService.perfomerInfoData, this.settingsData);
  }

  constructor(private _matDialog: MatDialog, private _formBuilder: FormBuilder,
    public router: Router,
    private appService: AppService, private landingPageService: LandingPageService,
    private ngxLoader: NgxUiLoaderService, private commanSubscribeService: CommanSubscribeService,
    private toastr: ToastrService,
    private storageService: StorageService,
    private activeRoute: ActivatedRoute,
    private userService: UserService,
    private utilityService: UtilityService) {
    this.returnUrl = this.activeRoute.snapshot.queryParams.returnUrl;
    this.referralCode = this.activeRoute.snapshot.queryParams.ref;
    this.mobileCallback = this.activeRoute.snapshot.queryParams.qrtype;
}
  ngOnInit(): void {
    this.channelName = this.router.url.split("/")[1];
    if(this.mobileCallback==='mobile'){
      this.router.navigateByUrl(this.channelName+'/404');
    }
    
    // Check affiliate access first
    if(this.referralCode){
      this.featureInfoSubscription = this.commanSubscribeService.getFeatureInfo().subscribe({
        next: (featureList: any) => {
          console.log("featureList", featureList);
          if (featureList?.length > 0 && !this.utilityService.isActiveFeature(featureList, 'affiliate')) {
            this.toastr.warning('Affiliates feature is not accessible to this channel');
            setTimeout(() => {
              this.router.navigateByUrl('/');
            }, 1000);
          }
        },
        error: (error) => {
          console.error('Error fetching feature info:', error);
          this.toastr.error('Error checking affiliate access');
        }
      });
    }

    this.buildForm();
    this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    this.userInfo = this.commanSubscribeService.userInfo;
    this.signUpInfo = this.commanSubscribeService.signUpInfo;
    this.liveEventInfo = this.userService.liveEvents;
    // localStorage.getItem("ThemelocalData")|| {}
    if (this.signUpInfo) {
      this.signUpForm.patchValue({
        email: this.signUpInfo.email,
        firstName: this.signUpInfo.firstName,
        lastName: this.signUpInfo.lastName,
        // phone_number: this.signUpInfo.phone_number
      })
    }
    if (this.activeRoute.snapshot.params.channelName) {
      try { ga('set', 'page', this.router.url); ga('send', 'pageview'); } catch (e) { }
    }
    this.getEventData = this.storageService.getItem('eventInfo');
    if (this.userInfo && Object.keys(this.userInfo)?.length != 0 && !this.userInfo.is_guest) {
      if (this.getEventData) {
        if (this.getEventData.isEvent == 'channels') {
          this.router.navigateByUrl(`/c/${this.getEventData.channel_name}/profile`)
        } else if (this.getEventData.isEvent == 'vod') {
          this.router.navigateByUrl(`${this.router.url.split("/")[1]}/watch/${this.getEventData.id}`)
        } else if (this.getEventData.isEvent == 'live' || this.getEventData.isEvent == 'upcoming') {
          this.router.navigateByUrl(`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/${this.getEventData.slug}/place-order`);
          // if (this.getEventData.number_of_creators > 1) {
          //   this.router.navigateByUrl(`/group-stream/${this.getEventData.id}`);
          // } else {
          //   this.router.navigateByUrl(`/stream/${this.getEventData.id}`);
          // }
        }
      } else {
        this.router.navigateByUrl('/' + this.channelName);
      }
      // this.router.navigate(['/userhome']);
    }
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.signUpInfoSubscription = this.commanSubscribeService.getSingUpInfo().subscribe(response => {
      this.signUpInfo = response;
    });
    this.settingsDataSubscription = this.commanSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response;
    })
    const initialPerformerInfo = this.commanSubscribeService.perfomerInfoData;
    if (initialPerformerInfo?.data?.Data?.[0]?.organization_id) {
      this.organizationId = initialPerformerInfo.data.Data[0].organization_id;
    }
    this.performerInfoSubscription = this.commanSubscribeService.getPerfomerInfo().subscribe(response => {
      if (response?.data?.Data?.[0]?.organization_id) {
        this.organizationId = response.data.Data[0].organization_id;
      }
    });
    // console.log( this.settingsDataSubscription, this.settingsData )
    this.channelUrl = this.storageService.getItem('channelName')
    if (!this.router.url.includes(this.channelUrl)) {
      this.settingsData = {}
    }
  }

  buildForm() {
    this.signUpForm = this._formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, ValidationService.emailValidator, Validators.pattern(EMAIL_REGEX)]],
      // phone_number: ['', [Validators.required, isValiddateNumber.isvalidNumber(false)]],
      // date_of_birth: ['', Validators.required],
      password: ['', [Validators.required, ValidationService.isStrongPassword(this.passwordIsValid)]],
      confirmPassword: ['', [Validators.required, ValidationService.confirmPasswordValidator]],
      referral_code: [{ value: this.referralCode ? this.referralCode : "", disabled: this.referralCode ? true : false }],
      user_type: [3],
      plan: [localStorage.plan_id ? localStorage.plan_id : 0],
      signature: []
    });
  }

  signUpUser() {

    if (this.signUpForm.valid) {

      if (!this.isAgrees) {
        this.toastr.error('Please accept terms and conditions');
        return;
      }

      // if (this.captcharesponse == '') {
      //   this.toastr.error('Please select captcha');
      //   return;
      // }

      let userData: any = this.signUpForm.getRawValue();
      if (userData.email.split('@')[1] == 'yopmail.com') {
        this.toastr.error('Please enter valid email');
        return;
      }
      userData.captcharesponse = this.captcharesponse;
      userData.reCaptchaClientKey = this.captchaKey;
      this.verifyCaptcha((val: any) => {
        if (val == "success") {
          let data = this.signUpForm.getRawValue();
          data.email = data.email.toLowerCase();
          let date = new Date();
          date.setFullYear(date.getFullYear() - parseInt(data.date_of_birth));
          let birthdate = moment((date.getMonth() + 1) + '/' + (date.getDate()) + '/' + (date.getFullYear())).format("YYYY-MM-DD");
          this.ngxLoader.start();
          Auth.signUp({
            username: data.email,
            password: data.password,
            attributes: {
              name: data.firstName,
              phone_number: data.phone_number || '',
              email: data.email,
              family_name: data.lastName,
              referral_code: data.referral_code,
              birthdate: '',
              // "custom:signature": this.signUpdata.signature,
              "custom:plan": data.plan ? data.plan.toString() : "0"
            },
            validationData: []
          }).then(resData => {
            this.ngxLoader.stop();
            this.openVerificationCode(data);
            this.router.navigate([''], { queryParams: { returnUrl: this.returnUrl } });
            if (resData && resData.codeDeliveryDetails && resData.codeDeliveryDetails.Destination) {
              this.toastr.success("Verification code sent to the " + resData.codeDeliveryDetails.Destination);
            }
          }).catch(err => {
            this.ngxLoader.stop();
            if (err) {
              if (err.code == AWS_RES_STATUS_CODE.NOT_AUTHORIZED_EXCEPTION) {
                this.toastr.error("Unable to verify secret key");
              } else {
                this.toastr.error(err.message);
              }
            }
            console.log(err);
          });
        }
      });
    }
  }

  openVerificationCode(formdata) {
    const dialogRef = this._matDialog.open(ConsumerVerificationCodeComponent, {
      maxWidth: "320px",
      panelClass: Object.keys(this.settingsData).length > 0 && this.settingsData.form_bg_color ? "app-consumer-signin" : "app-consumer-verification-code",
      disableClose: false,
      data: {
        formdata: formdata,
        request_from: "signup"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "yes") {
      }
    });
  }

  openConsumerAcceptTeams(isAgrees) {
    // event.preventDefault();
    if (isAgrees) {
      const dialogRef = this._matDialog.open(ConsumerAcceptTeamsComponent, {
        // maxWidth:"320px",
        panelClass: Object.keys(this.settingsData).length > 0 && this.settingsData.form_bg_color ? "app-consumer-signin" : "app-consumer-accept-teams",
        disableClose: true,
        data: {}
      });
      dialogRef.afterClosed().subscribe(result => {
        // if (result.close == false) {
        //   this.signUpForm.patchValue({ signature: result.signature });
        // } else if (result.close == true) {
        //   this.isAgrees = false;
        //   this.signUpForm.patchValue({ signature: "" });
        // }
      });
    }
    // else {
    //   this.signUpForm.patchValue({ signature: "" });
    // }
  }


  OpenSign() {
    this.landingPageService.openConsumerSignIn();
  }

  verifyCaptcha(callback: (val: any) => void) {
    callback('success');
    // let data = {
    //   captcharesponse: this.captcharesponse,
    //   reCaptchaClientKey: this.captchaKey
    // }
    // this.ngxLoader.start();
    // this.appService.postRequest(API.VERIFY_CAPTCHA, data).subscribe(result => {
    //   this.ngxLoader.stop();
    //   callback('success');
    // }, error => {
    //   this.ngxLoader.stop();
    //   console.log('error =', error);
    //   if (error.status == 401 || error.status == 402) {
    //     this.toastr.error("Invalid captcha code");
    //   } else if (error.status == 500) {
    //     this.toastr.error("Server Error");
    //   }
    //   callback('error');
    // });
  }

  resolved(captchaResponse: string) {
    this.captcharesponse = captchaResponse;
  }

  openDatePicker() {
    $('#date_of_birth').flatpickr({
      defaultDate: new Date(),
      maxDate: new Date(),
      disableMobile: 'true',
      onChange: (selectedDates, dateStr, instance) => {
        let selected = moment(dateStr).format("DD MMM YYYY");
        this.signUpForm.patchValue({
          date_of_birth: selected
        });
      },
      onClose: (selectedDates, dateStr, instance) => {
      }
    }).open();

  }


  checkStrength(p) {
    // 1
    let force = 0;

    // 2
    const regex = /[$-/:-?{-~!"^_@`\[\]]/g;
    const lowerLetters = /[a-z]+/.test(p);
    const upperLetters = /[A-Z]+/.test(p);
    const numbers = /[0-9]+/.test(p);
    const symbols = regex.test(p);

    // 3
    const flags = [lowerLetters, upperLetters, numbers, symbols];

    // 4
    let passedMatches = 0;
    for (const flag of flags) {
      passedMatches += flag === true ? 1 : 0;
    }

    // 5
    force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
    force += passedMatches * 10;

    // 6
    // force = (p.length <= 6) ? Math.min(force, 10) : force;
    force = (p.length <= 7) ? Math.min(force, 10) : force;

    // 7
    force = (passedMatches === 1) ? Math.min(force, 10) : force;
    force = (passedMatches === 2) ? Math.min(force, 20) : force;
    force = (passedMatches === 3) ? Math.min(force, 30) : force;
    force = (passedMatches === 4) ? Math.min(force, 40) : force;

    return force;
  }

  passwordValid(event) {
    this.passwordIsValid = this.checkStrength(this.signUpForm.get('password').value) == 40 ? true : false;
    setTimeout(() => {
      this.signUpForm.get('password').setValidators([Validators.required, ValidationService.isStrongPassword(this.passwordIsValid)]);
      this.signUpForm.get('password').updateValueAndValidity();
    }, 100);
  }





  newSignUpUser() {

    if (this.signUpForm.valid) {

      if (!this.isAgrees) {
        this.toastr.error('Please accept terms and conditions');
        return;
      }

      let userData: any = this.signUpForm.getRawValue();
      if (userData.email.split('@')[1] == 'yopmail.com') {
        this.toastr.error('Please enter valid email');
        return;
      }

      userData.captcharesponse = this.captcharesponse;
      userData.reCaptchaClientKey = this.captchaKey;

      this.verifyCaptcha((val: any) => {
        if (val == "success") {
          let data = this.signUpForm.getRawValue();
          data.email = data.email.toLowerCase();
          let date = new Date();
          date.setFullYear(date.getFullYear() - parseInt(data.date_of_birth));
          let birthdate = moment((date.getMonth() + 1) + '/' + (date.getDate()) + '/' + (date.getFullYear())).format("YYYY-MM-DD");
          // If this signup happened via a group-specific URL (/:channelName/:groupName/sign-up),
          // ChannelWebpageGuard has already matched :groupName and populated activeGroupId/Slug -
          // record which group the fan registered from as a permanent fact on their account.
          const signupGroupAttributes = this.commanSubscribeService.activeGroupId
            ? {
                signup_group_id: this.commanSubscribeService.activeGroupId,
                signup_group_slug: this.commanSubscribeService.activeGroupSlug || '',
              }
            : {};
          let reqData = {
            firstname: data.firstName,
            lastname: data.lastName,
            email: data.email,
            username: data.email,
            phone: data.phone_number || '',
            password: data.password,
            password_confirmation: data.confirmPassword,
            referral_code: data.referral_code,
            organization_id: this.organizationId || 0,
            custom_attributes: {
              date_of_birth: '',
              plan: data.plan ? data.plan.toString() : "0",
              profile_pic: "",
              user_display_name: data.firstName + " " + data.lastName,
              user_type: 3,
              is_user_verify: 0,
              roles: 'fan',
              domain:environment.clientDetails?.name,
              ...signupGroupAttributes
            }
          }
          this.ngxLoader.start();
          this.appService.postRequest(API.FAN_SIGNUP, reqData).subscribe(result => {

            // this.appService.OL_PostRequest(CONST_ONE_API.RESET_PASSWORD, { email : data.email } ).subscribe(result1 => {
            //   if(result1.status.code == 200){
            //     this.toastr.success("Registration successfully verification sent to your mail.");
            //     this.router.navigateByUrl("");
            //   }
            // }, error => {
            //     this.ngxLoader.stop();    
            // });

            // let req = { factor_id : 60000 , display_name : "Arevea Tv" , expires_in : 900 };
            // this.appService.OL_PostRequest(`api/2/mfa/users/${result.id}/registrations`, req ).subscribe(result1 => {
            //   if(result1.id) {
            // data.registration_id = result1.id;
            // this.oneLoginHook(result.id,(val: any) => {
            this.ngxLoader.stop();
            if (result && result.id) {
              if (this.router.url.includes(this.channelUrl)) {
                this.commanSubscribeService.trackGoogleAnalytics('sign_up');
                this.commanSubscribeService.trackFBEvents('CompleteRegistration');
              }
              data.user_id = result.id;
              this.openVerificationCode(data);
              // this.toastr.success("Verification code sent to the " + data.email);
              // Preserve the group segment (if any) so the fan stays at the group-level page
              // while the OTP dialog is open, instead of dropping to the channel root - losing
              // it here resets activeGroupId before verification completes, which previously
              // broke seeding the fan's group preference below.
              if (Object.keys(this.settingsData).length > 0) {
                const pathOnly = this.router.url.split('?')[0];
                const groupSegment = getGroupSegment(pathOnly);
                this.router.navigate(['/' + pathOnly.split('/')[1] + (groupSegment ? '/' + groupSegment : '')]);
              } else {
                this.router.navigateByUrl("");
              }
              // this.router.navigateByUrl("");
            }
            if (result && result.message) {
              this.toastr.success(result.message);
            } else {
              this.toastr.error('Something went wrong');
            }
            // });
            //   }
            // }, error => {
            //     this.ngxLoader.stop();    
            // });

          }, error => {
            this.ngxLoader.stop();
            if (error && error.error && error.error.message) {
              if (error.error.statusCode == 422 && error.error.message == "Validation failed: Email must be unique within " + environment.oneLogin.subDomain) {
                this.toastr.error("An Account with given email already exists.");
              } else {
                this.toastr.error(error.error.message);
              }
            }
          });
        }
      });
    } else {
      console.log(this.signUpForm);
    }
  }

  oneLoginHook(user_id, callback: (val: any) => void) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: [
        { "user_id": user_id, "event_type_id": 13 }
      ]
    }
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.ONELOGIN_HOOK, data).then(response => {
      if (response.data.statusCode == 200) {
        callback("success");
      } else {
        callback("error");
      }
    }).catch(error => {
      this.ngxLoader.stop();
      callback("error");
    });
  }

  ngOnDestroy() {
    delete localStorage.plan_id;
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
    if (this.signUpInfoSubscription)
      this.signUpInfoSubscription.unsubscribe();
    if (this.featureInfoSubscription)
      this.featureInfoSubscription.unsubscribe();
    if (this.performerInfoSubscription)
      this.performerInfoSubscription.unsubscribe();
    this.commanSubscribeService.sendSignUpInfo({});
  }

}